import React from 'react'
import './index.less'

export interface AppRowProps{
    style?:React.CSSProperties
    itemSplit?:number
}

export class AppRow extends React.Component<AppRowProps>{
    render() {
        if(this.props.children){
            return (
            <div style={this.props.style} className='app-row-container'>
                <div className='app-row'>
                    {React.Children.toArray(this.props.children).map(
                            (child:any,index:number)=>{
                                let paddingLeft = index===0? 0:(this.props.itemSplit||20)
                                return <div key={index} className='app-row-item ' style={{paddingLeft}}> {child}</div>
                            }
                        )}
                </div>
            </div>)
        }
            
        return <React.Fragment/>
        
    }
}


// WEBPACK FOOTER //
// ./src/qcc/AppRow/index.tsx